import {
  ICustomCategory,
  ICustomCategoryValue,
  IEmbeddedCustomCategory,
} from 'types/income';
import { converters as tableConverters } from 'store/table';
import {
  CustomCategory,
  CustomCategoryValue,
  EmbeddedCustomCategory,
} from './custom-categories.types';
import { loaders } from './custom-categories.loaders';

const convertCustomCategory = (category: ICustomCategory): CustomCategory => {
  return {
    id: category.id,
    name: category.name,
    values:
      category.values?.map((value) => ({
        id: value.id,
        name: value.name,
      })) ?? [],
  };
};

export const convertCustomCategories = (
  categories: ICustomCategory[],
): CustomCategory[] => {
  return categories.map(convertCustomCategory);
};

const convertEmbeddedCustomCategory = (
  category: IEmbeddedCustomCategory,
): EmbeddedCustomCategory => {
  return {
    id: category.id,
    name: category.name,
    value: {
      id: category.valueId,
      name: category.value,
    },
  };
};

export const convertEmbeddedCustomCategories = (
  categories: IEmbeddedCustomCategory[],
): EmbeddedCustomCategory[] => {
  return categories.map(convertEmbeddedCustomCategory);
};

const convertCustomCategoryValue = (
  value: ICustomCategoryValue,
): CustomCategoryValue => {
  return {
    id: value.id,
    name: value.name,
    employeeCount: Number(value.employeeCount),
  };
};

export const convertCustomCategoryValues = (
  values: ICustomCategoryValue[],
): CustomCategoryValue[] => {
  return values.map(convertCustomCategoryValue);
};

export const converters = {
  getCustomCategories: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getCustomCategories>>) => {
    return convertCustomCategories(data.data);
  },
  getCustomCategoryValues: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getCustomCategoryValues>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertCustomCategoryValues(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
};
